import { send } from './client';
import type { TestResult } from './common';
import { query, type Cursor, type CursorPage } from './paging';

// A Bengkel Uji's verdicts on a cylinder: recorded by an operator of the workshop where it is, listed on its page.

/** One Bengkel Uji verdict (GET /cylinders/:id/tests, the detail's `tests`). */
export interface CylinderTest {
  id: number;
  result: TestResult;
  testedAt: string;
  /** YYYY-MM-DD (WIB) */
  testedOn: string;
  /** PASS: the next retest (YYYY-MM-DD); FAIL: null */
  nextTestDue: string | null;
  reason: string | null;
  /** the withdrawal it arrived on (the test session) and its number */
  shipmentId: number;
  shipmentNumber: string | null;
  locationId: number;
  locationName: string | null;
  /** the operator who recorded it */
  testedByName: string | null;
}

export type CylinderTestPage = CursorPage<CylinderTest>;

/**
 * POST /cylinders/:id/tests: a Bengkel Uji's verdict, by an operator of the workshop where the cylinder is. PASS with
 * the next retest day (after today, at most CYLINDER_TEST.maxIntervalYears later), FAIL with the reason (destroyed for
 * good). The same verdict again answers the stored one.
 */
export type CylinderTestInput = { result: 'PASS'; nextTestDue: string; reason?: string | null } | { result: 'FAIL'; reason: string };

export const cylinderTestPaths = {
  /** newest first, keyset pages by test id */
  list: (id: number, cursor: Cursor, limit: number) => `/cylinders/${id}/tests${query({ ...cursor, limit })}`,
};

/** A Bengkel Uji's verdict (cylinder.test, operators of the workshop where it is): answers the stored result. */
export const recordCylinderTest = (id: number, body: CylinderTestInput) => send<CylinderTest>(`/cylinders/${id}/tests`, body);
